import { cn } from "@/lib/utils";

interface LoadingIndicatorProps {
  className?: string;
}

export const LoadingIndicator = ({ className }: LoadingIndicatorProps) => {
  return (
    <div
      className={cn("fixed inset-x-0 top-0 z-50 h-1 animate-pulse", className)}
    >
      <div className="animate-loading-bar h-full w-full bg-gradient-to-r from-lime-100 to-lime-500" />
    </div>
  );
};
